import * as AddDataSourceActionTypes from 'automation-ui-formula-editor/fetch-object-panel/actions/AddDataSourceActionTypes';
export function selectTargetObjectChangeAction({
  objectTypeId
}) {
  return {
    type: AddDataSourceActionTypes.SELECT_TARGET_OBJECT_TO_ADD,
    objectTypeId
  };
}
export function selectFilterRecordsByAction({
  recordFilterType
}) {
  return {
    type: AddDataSourceActionTypes.SELECT_FILTER_RECORD_BY,
    recordFilterType
  };
}
export function selectAssociationIdAction({
  associationId
}) {
  return {
    type: AddDataSourceActionTypes.SELECT_ASSOCIATION_ID,
    associationId
  };
}
export function selectSortByAction({
  selectRecordBy
}) {
  return {
    type: AddDataSourceActionTypes.SELECT_SORT_BY,
    selectRecordBy
  };
}
export function selectSortByAssociationTimestampAction({
  associationTimestampOrder
}) {
  return {
    type: AddDataSourceActionTypes.SELECT_SORT_BY_ASSOCIATION_TIMESTAMP,
    associationTimestampOrder
  };
}
export function selectMatchingDataSourcePropertyAction({
  propertyName
}) {
  return {
    type: AddDataSourceActionTypes.SELECT_MATCHING_DATA_SOURCE_PROPERTY,
    propertyName
  };
}
export function selectMatchingEnrolledPropertyAction({
  propertyName
}) {
  return {
    type: AddDataSourceActionTypes.SELECT_MATCHING_ENROLLED_PROPERTY,
    propertyName
  };
}
export function selectMatchingPropertyValueAction({
  value
}) {
  return {
    type: AddDataSourceActionTypes.SELECT_MATCHING_PROPERTY_VALUE,
    value
  };
}
export function renameDataSourceAction({
  label
}) {
  return {
    type: AddDataSourceActionTypes.RENAME_DATA_SOURCE,
    label
  };
}